import React, { useEffect } from "react";
import classes from "./LandingPage.module.css";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { useMultiStepForm } from "../Provider/MultiStepFormContext";
import { useAlternateProductContext } from "../User/AlternateProductContext";

export const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const handleClick = (type: "provider" | "user") => {
    navigate(`/consignee?type=${type}`);
  };

  const { clearFormData } = useMultiStepForm();
  const { clearAlternateProductData } = useAlternateProductContext();

  useEffect(() => {
    clearFormData();
    clearAlternateProductData();
  }, []);

  const savedCountry = sessionStorage.getItem("country") ?? "";
  const countriesWithNoUserFlow = ["KR", "TW", "HK", "SG", "Hant"];
  const hasEndUserFlow = countriesWithNoUserFlow.includes(savedCountry);

  return (
    <div className={classes.container}>
      <h1 className={classes.title}>{t("iama")}</h1>
      <div className={classes.buttonContainer}>
        {savedCountry !== "NZ" && (
          <button
            className={classes.button}
            onClick={() => handleClick("provider")}
          >
            {t("provider")}
          </button>
        )}
        {!hasEndUserFlow && (
          <button
            className={classes.button}
            onClick={() => handleClick("user")}
          >
            {t("enduser")}
          </button>
        )}
      </div>
    </div>
  );
};
